import { BUTTON_HEIGHT, FONT_SIZE, TEXT_SCALE_PROPS } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import styled from "styled-components";
const WIDTH_TIME_PICKER = {
  [DISPLAY_SIZES.SMALL]: 83,
  [DISPLAY_SIZES.MEDIUM]: 87,
  [DISPLAY_SIZES.LARGE]: 95,
};
export const Styles = styled.div<TEXT_SCALE_PROPS>`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: ${({ text_scale }) =>
    FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};

  > span {
    white-space: nowrap;
  }

  .ant-picker {
    width: ${({ text_scale }) =>
      `${WIDTH_TIME_PICKER[text_scale || DISPLAY_SIZES.SMALL]}px`};
    height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale || DISPLAY_SIZES.SMALL]}px`};

    input {
      font-size: ${({ text_scale }) =>
        FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
    }
  }
`;
